module.exports = __webpack_public_path__ + "images/regions.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/RegionMenu/images/regions.png
// module id = 2144
// module chunks = 6 7 17 18